// extracted by css-extract-rspack-plugin
var _1 = "f3";
var _2 = "fk";
export { _1 as "icon", _2 as "mapLinkComponent" }
